import { Component } from '@angular/core'
import { EditPage } from '../../../utils/services/can-deactivate-guard.service'

@Component({
  selector: 'cover-edit-payment-method',
  templateUrl: './edit-payment-method.component.html',
  styleUrls: ['./edit-payment-method.component.scss'],
})
export class EditPaymentMethodComponent extends EditPage {
  // subscriptions: Subscriptions = new Subscriptions()
  // formState$: Observable<FormGroupState<DebitCharge>>
  // currentPaymentData$: Observable<DebitCharge>
  // paymentMethodLoaded$: Observable<PendingState | undefined>
  // readonly pendingState = PendingState
  // company: string = ''
  //
  // constructor(private readonly store: Store, private readonly router: Router, private readonly route: ActivatedRoute) {
  //   super()
  //   this.formState$ = this.store.select(selectPaymentMethodsState.editPaymentMethodsControls)
  //   this.currentPaymentData$ = this.store.select(selectPaymentMethodsState.paymentMethodToEdit)
  //   this.paymentMethodLoaded$ = this.store.select(selectPaymentMethodsState.loadedPaymentMethodToEdit)
  //   this.subscriptions.plusOne = this.currentPaymentData$
  //     .pipe(
  //       tap(res => {
  //         if (JSON.stringify(res) === JSON.stringify(initialPaymentMethodToEdit)) {
  //           this.router.navigate(['../'], { relativeTo: this.route })
  //         }
  //       }),
  //     )
  //     .subscribe()
  // }
}
